export const AngelAndroid =
  "https://play.google.com/store/apps/details?id=com.korean.akb";
export const AngelIos =
  "https://apps.apple.com/us/app/angel-korean-bhasha/id6468964648";
